import { Button, TextField, Typography } from '@mui/material';
import React, { FunctionComponent } from 'react';
import { FieldErrors, UseFormRegister } from 'react-hook-form';

export interface BedroomFormInputs {
  floor: number;
  doorNumber: string;
  maxUsers: number;
}

interface BedroomFormProps {
  onSubmit: () => void;
  register: UseFormRegister<BedroomFormInputs>;
  errors: FieldErrors<BedroomFormInputs>;
  submitButtonLabel: string;
}

export const BedroomForm: FunctionComponent<BedroomFormProps> = ({
  onSubmit,
  register,
  errors,
  submitButtonLabel,
}) => {
  return (
    <form onSubmit={onSubmit}>
      <TextField
        margin="normal"
        fullWidth
        id="doorNumber"
        label="Numéro de la chambre"
        placeholder='Ex: "11A"'
        autoFocus
        type="text"
        {...register('doorNumber')}
        helperText={
          errors.doorNumber?.message ? (
            <Typography component="p" variant="body2" color="error.main">
              {errors.doorNumber.message}
            </Typography>
          ) : null
        }
      />
      <TextField
        margin="normal"
        fullWidth
        id="floor"
        label="Étage"
        placeholder="Ex: 1"
        type="number"
        {...register('floor')}
        helperText={
          errors.floor?.message ? (
            <Typography component="p" variant="body2" color="error.main">
              {errors.floor.message}
            </Typography>
          ) : null
        }
      />
      <TextField
        margin="normal"
        fullWidth
        id="maxUsers"
        label="Nombres de places dans le chambre"
        placeholder="Ex: 5"
        type="number"
        {...register('maxUsers')}
        helperText={
          errors.maxUsers?.message ? (
            <Typography component="p" variant="body2" color="error.main">
              {errors.maxUsers.message}
            </Typography>
          ) : null
        }
      />

      <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
        {submitButtonLabel}
      </Button>
    </form>
  );
};
